import { FC, Fragment } from 'react';
// Mui
import { Fab } from '@mui/material';
// Hooks
import useToggle from 'app/hooks/useToggle';
// 
import SubscriptionPackageDialog from './SubscriptionPackageDialog';
// i18next
import { useTranslation } from 'react-i18next';

const SubscriptionsFab:FC = () => {
  const { t } = useTranslation();

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      <Fab
        name="Create subscription"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16
        }}
        onClick={toggle}
        color="primary"
        variant="extended"
      >{t('pages.subscriptions.createButton')}</Fab>
      {/* Package form dialog */}
      {open ? (
        <SubscriptionPackageDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default SubscriptionsFab;
